<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">Query Management</h1>
        </div>
        <div class="content-section">
            <div class="outer-box">
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="table-responsive">
                            <table class="table table-bordered" aria-describedby="">
                                <thead>
                                    <tr class="no_wrap_th text-center">
                                        <th class="Sorting-img" scope="col">S.No.</th>
                                        <th scope="col" class="Sorting-img">Name</th>
                                        <th scope="col" class="Sorting-img">Email</th>
                                        <th scope="col" class="Sorting-img">Description</th>
                                        <th scope="col" class="action_td_btn3 Sorting-img">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (
                                    item of queryListData
                                        | paginate: {
                                            itemsPerPage: itemPerPage,
                                            currentPage: currentPage,
                                            totalItems: total
                                        };
                                    track item?._id;
                                    let i = $index
                                    ) {
                                    <tr class="text-center">
                                        <td>{{ itemPerPage * (currentPage - 1) + i + 1 }}</td>

                                        <td class="content">
                                        {{ item?.userId?.firstName || '--' }} {{ item?.userId?.lastName || '' }}
                                        </td>

                                        <td class="content">
                                        {{ item?.userId?.email || '--' }}
                                        </td>

                                        <td class="content">
                                        {{ item?.query || '--' }}
                                        </td>

                                        <td class="justify-content-center align-items-end d-flex action_td">
                                        <button
                                            class="btn btn-info ms-2 bt-margin"
                                            [routerLink]="['/view-query/', item._id]"
                                        >
                                            <i class="fa fa-eye" style="color:white"></i>
                                        </button>

                                        <button
                                            class="btn btn-danger ms-2 bt-margin"
                                            title="delete"
                                            (click)="deleteUserModal(item._id)"
                                        >
                                            <i class="fa fa-trash" style="color:white"></i>
                                        </button>
                                        </td>
                                    </tr>
                                    }

                                    @if(!queryListData.length){
                                    <tr>
                                        <td class="table-no-record" colspan="6">No Record Found</td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                            @if(total > 10){
                            <div class="custom-pagination mt-2 text-align-end">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- delete hospital modal Start -->
<div class="modal fade global-modal reset-modal" id="deleteUser">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div class="modal-header d-block text-center modal-header-custm">
                    <h5 class="modal-title d-inline-block">Delete Query</h5>
                </div>
                <div class="modal-inner-content">
                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure you want to delete this Query?</p>
                                <div class="modal-btn-box">
                                    <button type="submit" class="btn btn-theme" (click)="deleteQuery()">Yes</button>
                                    <button type="button" class="btn btn-danger ms-2" style="min-width: 100px;"
                                        data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- end delete hospital modal -->